import { render } from "./waybillQuery.vue?vue&type=template&id=52bcf708&scoped=true"
import script from "./waybillQuery.vue?vue&type=script&lang=js"
export * from "./waybillQuery.vue?vue&type=script&lang=js"

import "./waybillQuery.vue?vue&type=style&index=0&id=52bcf708&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52bcf708"]])

export default __exports__